export enum MetadataField {
  PROJECT = 'PROJECT',
  PRODUCT = 'PRODUCT',
  PRODUCT_FORMAT = 'PRODUCT FORMAT',
  GEOGRAPHY = 'GEOGRAPHY',
}
